import { createContext } from "react";
import { ConfirmModalData } from "../components/Common/Modals/ConfirmModal/ConfirmModal";
import { AlertBlock, AlertData } from "../components/Common/AlertManager/AlertManager.tsx";
import { GenericModalData } from "../components/Common/Modals/GenericModal/GenericModal";
import { NameModalData } from "../components/Common/Modals/NameModal/NameModal";

export type ModalType = "confirm" | "name" | "generic" | "none";
export type ModalProps = ConfirmModalData | GenericModalData | NameModalData | undefined;

interface AppStates {
  loading: boolean;
  setLoading: (value: boolean) => void;

  showModal: ModalProps;
  showModalType: ModalType;
  setShowModal: (modalType: ModalType, value: ModalProps) => void;

  alerts: AlertBlock[];
  pushAlert: (value: AlertData) => void;
  removeAlert: (id: number) => void;

  tutorial: boolean;
  setTutorial: (value: boolean) => void;
}

export const AppContext = createContext<AppStates>({
  loading: false,
  setLoading: () => {},

  showModal: undefined,
  showModalType: "generic",
  setShowModal: () => {},

  alerts: [],
  pushAlert: () => {},
  removeAlert: () => {},

  tutorial: false,
  setTutorial: () => {},
});
